// 通用下载工具

/**
 * 将 Blob 响应保存为本地文件
 * @param {Blob} blob - 文件二进制内容
 * @param {string} fileName - 下载文件名
 */
export function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName || 'download.xlsx'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

/**
 * 解析 blob 下载接口的错误提示：独立 axios 实例无全局拦截器，
 * 错误体为 Blob 时尝试解析后端返回的 message
 * @param {Error} error - axios 错误对象
 * @param {string} [fallback] - 兜底提示文案
 * @returns {Promise<string>}
 */
export async function resolveBlobErrorMessage(error, fallback = '导出失败') {
  const data = error?.response?.data
  if (data instanceof Blob) {
    try {
      const parsed = JSON.parse(await data.text())
      if (parsed?.message) return parsed.message
    } catch {
      // 非 JSON 错误体，走默认提示
    }
  }
  return error?.message || fallback
}

/**
 * 生成 yyyyMMdd 格式的日期串，用于导出文件名
 * @param {Date} [date] - 日期，默认当前时间
 * @returns {string}
 */
export function formatDateCompact(date = new Date()) {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}${m}${d}`
}
